import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { I18nService } from '@/core/services/i18nService';
import { PortalContextService } from '@/core/services/portal-context.service';
import { AnfrageTransformerService } from './anfrage-transformer.service';

@Injectable({
    providedIn: 'root'
})
export class AnfrageLanguageService implements OnDestroy {
    private languageBefore: string | null = null;
    private destroy$ = new Subject<void>();
    private isAnfrageLanguageActive = false;

    constructor(
        protected router: Router,
        protected languageService: I18nService,
        protected portalContextService: PortalContextService,
        protected anfrageTransformService: AnfrageTransformerService
    ) {
        this.initRouteListener();
    }

    private initRouteListener(): void {
        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                takeUntil(this.destroy$)
            )
            .subscribe(() => {
                this.handleRouteChange();
            });
    }

    private handleRouteChange(): void {
        let route: ActivatedRoute | null = this.router.routerState.root;
        let shouldUseAnfrageLanguage = false;

        // Traverse durch die gesamte route tree
        while (route !== null) {
            if (route.snapshot.data['useAnfrageLanguage']) {
                shouldUseAnfrageLanguage = true;
                break;
            }
            route = route.firstChild;
        }

        if (shouldUseAnfrageLanguage && !this.isAnfrageLanguageActive) {
            this.activateAnfrageLanguage();
        } else if (!shouldUseAnfrageLanguage && this.isAnfrageLanguageActive) {
            this.deactivateAnfrageLanguage();
        }
    }

    private activateAnfrageLanguage(): void {
        const anfrage = this.portalContextService.CurrentAnfrage;
        if (anfrage?.ausschreibungSprache) {
            this.isAnfrageLanguageActive = true;
            this.languageBefore = this.languageService.language;
            this.languageService.SetCurrLanguageFromEnum(anfrage.ausschreibungSprache);
            this.languageService.forceHideLanguageDropdown = true;
            this.anfrageTransformService.transform(anfrage).then(transformedAnfrage => this.portalContextService.CurrentAnfrage = transformedAnfrage);
        }
    }

    private deactivateAnfrageLanguage(): void {
        if (this.languageBefore) {
            this.isAnfrageLanguageActive = false;
            this.languageService.language = this.languageBefore;
            this.languageService.forceHideLanguageDropdown = false;
            this.languageBefore = null;
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}